<template>
  <div class="md-layout">
    <!-- VIEW AUDIT DETAIL MODAL-->
    <md-dialog :md-active.sync="showDetailsModal" class="big-modal">
      <md-dialog-title style="padding-left: 37px">
        {{detailModaltitle}}
      </md-dialog-title>

      <md-dialog-content>
        <div class="md-layout-item md-size-100">
          <div class="md-layout">
            <div class="md-layout-item md-size-50" v-if="auditDetail.pretty.action !== 'Creation'">
              <div><strong>Previous Details</strong></div>
              <div class="details-block">
                <p v-if="auditDetail.pretty.previous_data" v-for="(value, propertyName) in auditDetail.pretty.previous_data" :key="propertyName">
                  <b>{{ readableText(propertyName) }}</b>: {{ value || 'N/A'}}
                </p>
                <p v-if="!auditDetail.pretty.previous_data">
                  No data available
                </p>
              </div>
            </div>

            <div class="md-layout-item md-size-50">
              <div><strong>Current Details</strong></div>
              <div class="details-block">
                <p v-if="auditDetail.pretty.current_data" v-for="(value, propertyName) in auditDetail.pretty.current_data" :key="propertyName">
                  <b>{{ readableText(propertyName) }}</b>: {{ value || 'N/A'}}
                </p>
                <p v-if="!auditDetail.pretty.current_data">
                  No data available
                </p>
              </div>
            </div>
          </div>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <download-links-menu
          style="display: none;"
          :download-links="detailDownloadLinks"
          buttonName="Download"
          :object="auditDetail"
        >
        </download-links-menu>
        <md-button class="md-info pull-right" @click="downloadDetail()">Download</md-button>
        <md-button class="md-default pull-right" @click="showDetailsModal=false">Cancel</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!--FILTER AUDIT MODAL-->
    <md-dialog :md-active.sync="showAuditModal">
      <md-dialog-title>Audit Trail - {{auditBy.pretty.actor}} ({{auditBy.pretty.actor_type}})</md-dialog-title>

      <md-dialog-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-100">
            <div class="md-layout">
              <p><span><strong>Email</strong>: {{auditBy.pretty.actor_email}}</span> &nbsp;&nbsp; <span><strong>Phone</strong>: {{auditBy.pretty.actor_telephone}}</span> </p>
            </div>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-100">
            <div class="md-layout">
              <md-table
                style="width: 100%"
                :value="modalTableData"
                :md-sort.sync="currentSort"
                :md-sort-order.sync="currentSortOrder"
                :md-sort-fn="customSort"
                class="paginated-table table-striped table-hover"
              >
                <md-table-toolbar
                  style="margin: 5px 0 70px 0;"
                >
                  <span
                    class="description"
                    style="font-size: 15px;margin-bottom: -10px;font-weight: 700"
                  >Filters:</span>
                  <md-datepicker flex ref="modalStartDateFilter" v-model="modalStartDate" :md-debounce="$constants.dpBounce" md-immediately class="input-date-style">
                    <label>{{modalStartDate ? '' : 'Start Date'}}</label>
                  </md-datepicker>
                  <md-datepicker flex ref="modalEndDateFilter" v-model="modalEndDate" :md-debounce="$constants.dpBounce" md-immediately class="input-date-style">
                    <label>{{modalEndDate ? '' : 'End Date'}}</label>
                  </md-datepicker>

                  <md-button class="md-just-icon md-info" @click.native="filterSetModal=false; searchModalAudit();">
                    <md-icon>search</md-icon>
                    <md-tooltip md-direction="bottom">Filter</md-tooltip>
                  </md-button>
                  <md-button class="md-just-icon md-default" @click.native="clearModalSearch">
                    <md-icon>replay</md-icon>
                    <md-tooltip md-direction="bottom">Clear Filters</md-tooltip>
                  </md-button>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    style="width: 30%"
                    md-label="Tax Office"
                  >
                    <span>{{item.pretty.actor_office}}</span>
                  </md-table-cell>
                  <md-table-cell
                    style="width: 10%"
                    md-label="Action"
                  >
                    <span>{{item.pretty.action}}</span>
                  </md-table-cell>
                  <md-table-cell
                    style="width: 40%"
                    md-label="Action Performed On"
                  >
                    <span>{{item.pretty.entity_type}}</span>
                    <span>{{item.pretty.entity_reference}}</span>
                  </md-table-cell>
                  <md-table-cell
                    style="width: 20%"
                    md-label="Date & Time"
                  >
                    <span>{{$moment(item.done_at).format('DD MMM YYYY - HH:MM')}}</span>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </div>
        </div>
      </md-dialog-content>

      <md-card>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category"></p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="modalCurrentPage"
            :per-page="modalPagination.perPage"
            :total="totalModal"
            :dataAvailable="modalTableData.length > 0"
          ></pagination>
        </md-card-actions>
      </md-card>

      <md-dialog-actions>
        <md-button class="md-default" @click="showAuditModal = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>pages</md-icon>
          </div>
          <div class="page-ttl">
            <h4 class="title">Audit Trail</h4>
          </div>
          <download-links-menu :download-links="downloadLinks" :disabled="!enableDownload"></download-links-menu>
          <div style="float: right; margin-top: 12px">
            <md-button class="md-just-icon md-simple">
              <md-icon>info</md-icon>
              <md-tooltip md-direction="top">Download is only <br> available for filtered <br>data (max. of 100 audit logs)</md-tooltip>
            </md-button>
          </div>
        </md-card-header>

        <md-toolbar
          md-get-palette-color="red"
          style="margin-bottom: 50px; margin-top: 30px;"
        >
          <span
            class="description"
            style="font-size: 15px;margin-bottom: -10px;font-weight: 700"
          >Filters:</span>

          <md-field class="selectGroup">
            <v-select
              v-model="auditEntityTypeId"
              placeholder="Select Audit Entity Type"
              :reduce="aet => aet.id"
              label="label"
              :options="auditEntityTypes">
            </v-select>
          </md-field>

          <md-field class="selectGroup">
            <v-select
              v-model="userTypeId"
              placeholder="Select User Type"
              :reduce="aet => aet.id"
              label="label"
              :options="userTypes">
            </v-select>
          </md-field>

          <md-field class="selectGroup">
            <v-select
              v-model="adminUserId"
              placeholder="Select Admin"
              label="first_name"
              :reduce="usr => usr.id"
              :filter-by="adminFilter"
              :options="adminUsers">
              <template
                slot="option"
                slot-scope="option"
              >{{ option.first_name }} {{ option.last_name }}</template>
            </v-select>
          </md-field>
          <md-field class="selectGroup">
            <v-select
              v-model="taxPayerId"
              :placeholder="$constants.identityLabels.ebs"
              :reduce="aet => aet.id"
              label="reg_no"
              :filterable="false"
              @search="fetchTaxPayers"
              :options="taxPayers">
            </v-select>
          </md-field>
          <md-field class="selectGroup">
            <v-select
              v-model="auditActionId"
              placeholder="Select Audit Action"
              :reduce="aet => aet.id"
              label="name"
              :options="auditActions">
            </v-select>
          </md-field>
          <md-datepicker flex ref="startDateFilter" v-model="startDate" :md-debounce="$constants.dpBounce" md-immediately class="input-date-style">
            <label>{{startDate ? '' : 'Start Date'}}</label>
          </md-datepicker>
          <md-datepicker flex ref="endDateFilter" v-model="endDate" :md-debounce="$constants.dpBounce" md-immediately class="input-date-style">
            <label>{{endDate ? '' : 'End Date'}}</label>
          </md-datepicker>

          <div class="filter-btns">
            <div class="flt-btns">
              <md-button
                style="margin-bottom: -10px"
                class="md-danger md-sm"
                @click.native="clearSearch"
              >Reset</md-button>
              <md-button
                style="margin-bottom: -10px"
                class="md-success md-sm"
                @click.native="filterSet=false; searchAudit();"
              >Filter</md-button>
            </div>
          </div>
        </md-toolbar>

        <md-card-content>
          <md-table
            :value="tableData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                style="width: 20%"
                md-label="Action Performed On"
              >
                <span>{{item.pretty.entity_type}}</span><br/>
                <span>{{item.pretty.entity_reference}}</span><br/>
                <AuditTrailEntity :record-id="item.id">
                  <template slot-scope="{ open }">
                    <a class="view-more" href="javascript:void(0)" @click="open()">[View Details]</a>
                  </template>
                </AuditTrailEntity>

              </md-table-cell>

              <md-table-cell
                style="width: 5%"
                md-label="Action"
              >
                <span>{{item.pretty.action}}</span>
              </md-table-cell>
<!--              <md-table-cell-->
<!--                style="width: 20%"-->
<!--                md-label="Performed By"-->
<!--                class="clickable"-->
<!--                @click.native.prevent="openAuditByUser(item)"-->
<!--              >-->
<!--                <span>{{item.pretty.actor}}</span>-->
<!--              </md-table-cell>-->
              <md-table-cell
                style="width: 20%"
                md-label="Performed By"
                class="clickable"
              >
                <AuditTrailEntity :entity="item.user_type_object && item.user_type_object.name" :entity-id="item.user_id">
                  <template slot-scope="{ open }">
                    <span @click="open()">{{item.pretty.actor}}</span>
                  </template>
                </AuditTrailEntity>
              </md-table-cell>

              <md-table-cell
                style="width: 5%"
                md-label="Role"
              >
                <span>{{item.pretty.actor_type}}</span>
              </md-table-cell>

              <md-table-cell
                style="width: 15%"
                md-label="Tax Office"
              >
                <span>{{item.pretty.actor_office}}</span>
              </md-table-cell>

              <md-table-cell
                style="width: 10%"
                md-label="Phone"
              >
                <span>{{item.pretty.actor_telephone}}</span>
              </md-table-cell>

              <md-table-cell
                style="width: 15%; word-break: break-word;"
                md-label="Email"
              >
                <span>{{item.pretty.actor_email}}</span>
              </md-table-cell>

              <md-table-cell
                md-label="Date & Time"
              >
                <span>{{$moment(item.done_at).format('DD MMM YYYY - HH:MM')}}</span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category"></p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="currentPage"
            :per-page="pagination.perPage"
            :total="total"
            :dataAvailable="tableData.length > 0"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>

  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import constants from "@/constants";
import { Pagination, StatsCard } from "@/components";
import { readableText, sortAlphabetically, orderBy, clearDatePickers } from "@/lib/utils";

export default {
  components: {
    Pagination, StatsCard,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },

    total() {
      return this.pagination.total;
    },

    toModal() {
      let highBound = this.fromModal + this.modalPagination.perPage;
      if (this.totalModal < highBound) {
        highBound = this.totalModal;
      }
      return highBound;
    },

    fromModal() {
      return this.modalPagination.perPage * (this.modalCurrentPage - 1);
    },

    totalModal() {
      return this.modalPagination.total;
    }
  },

  data() {
    return {
      showDetailsModal: false,
      detailModaltitle: "",
      currentSort: "id",
      currentSortOrder: "desc",
      currentPage: 1,
      pagination: {
        perPage: 20,
        perPageOptions: [10, 20, 50, 100],
        total: 0
      },
      tableData: [],
      startDate: "",
      endDate: "",
      showAuditModal: false,
      modalCurrentPage: 1,
      modalPagination: {
        perPage: 20,
        perPageOptions: [10, 20, 50, 100],
        total: 0
      },
      modalTableData: [],
      auditBy: {
        pretty: {}
      },
      auditByFilters: "",
      modalStartDate: "",
      modalEndDate: "",
      taxPayers: [],
      taxPayerId: '',
      consultantId: '',
      adminUsers: [],
      adminUserId: '',
      auditActions: [],
      auditActionId: '',
      userTypes: [],
      userTypeId: '',
      auditEntityTypes: [],
      auditEntityTypeId: '',
      auditDetail: {
        pretty: {},
        current_data: {},
        previous_data: {}
      },
      adminFilter: (option, label, search) => {
        const temp = search.toLowerCase();
        return option.first_name.toLowerCase().indexOf(temp) > -1
          || option.last_name.toLowerCase().indexOf(temp) > -1;
      },
      downloadLinks: [
        { name: "Excel", reportFor: "AUDIT" },
        { name: "PDF", reportFor: "AUDIT" }
      ],
      enableDownload: false,
      detailDownloadLinks: [
        {name: 'PDF', reportFor: 'AUDIT_DETAIL'}
      ],
      filterSet: false,
      filterSetModal: false
    };
  },

  methods: {
    fetchTaxPayers(search) {
      const sortBy = orderBy('reg_no');
      if(!search) {
        return
      }
      const filters = [];
      filters.push({
        field: "reg_no",
        value: `%25${search}%25`,
        cond_op: "like"
      });
      const params = `filters=${JSON.stringify(filters)}&page=1&page_size=20${sortBy}`;
      this.$http
        .post(
          `tax/payers`,
          {
            params: params,
            method: "GET"
          },
          {
            params: {
              skipLoader: true
            }
          }
        )
        .then(
          response => {
            if (response.data) {
              if (response.data.error) {
                this._handleErrors(response.data);
              } else {
                this.taxPayers = response.data.list;
              }
            } else {
              this.notification(
                "Error fetching form template",
                "pan_tool",
                "danger"
              );
            }
          },
          error => {
            this.notification(error.message, "pan_tool", "danger");
          }
        );
    },

    checkNoDataExists(data) {
      // Audit pretty data cluld be blank array or an object with/without data.
      return Array.isArray(data) || (!Array.isArray(data) && !Object.keys(data).length);
    },

    getAuditDetails(item) {
      const apiUrl = `audit/trail/${item.id}`;
      this.$http.post(apiUrl,
        {
          method: "GET"
        }).then(
        response => {
          if (response.data) {
            if (response.data.error) {
              this._handleErrors(response.data);
            } else {
              this.showDetailsModal = true;
              this.auditDetail = response.data;

              const action = this.auditDetail.pretty.action === 'Creation' ? 'created' : this.auditDetail.pretty.action === 'Deletion' ? 'deleted' : 'updated';

              this.detailModaltitle = `${this.auditDetail.pretty.actor} ${action} beolow details on ${this.$moment(this.auditDetail.pretty.done_at).format('DD MMM YYYY - HH:MM')}`;

              const prevData = this.auditDetail.pretty.previous_data;
              const currentData = this.auditDetail.pretty.current_data;
              if(this.checkNoDataExists(prevData)) {
                this.auditDetail.pretty.previous_data = false;
              }
              if(this.checkNoDataExists(currentData)) {
                this.auditDetail.pretty.current_data = false;
              }
            }
          } else {
            this.notification(
              "An unknown error occurred",
              "pan_tool",
              "danger"
            );
          }
        },
        error => {
          this.notification(error.message, "clear", "danger");
        }
      );
    },

    readableText(str) {
      return readableText(str);
    },

    searchModalAudit() {
      let filters = [{"field": "user_type_id", "value": this.auditBy.user_type_id}, {"field": "user_id", "value": this.auditBy.user_id}];
      if(this.modalStartDate && this.modalEndDate) {
        filters.push({
          field: "done_at",
          value: this.modalStartDate,
          cond_op: ">="
        });

        filters.push({
          field: "done_at",
          value: this.modalEndDate,
          cond_op: "<="
        });

        if(!this.filterSetModal) this.modalCurrentPage = 1;

        this.filterSetModal = true;
      }

      let params = `filters=${JSON.stringify(filters)}`;
      this.getAuditTrail(params);
    },

    openAuditByUser(item) {
      this.modalCurrentPage = 1;
      this.showAuditModal = true;
      this.auditBy = item;
      this.auditByFilters = `filters=[{"field": "user_type_id", "value": "${item.user_type_id}"}, {"field": "user_id", "value": "${item.user_id}"}]`
      this.getAuditTrail(this.auditByFilters);
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },

    clearModalSearch() {
      this.modalStartDate = "";
      this.modalEndDate = "";
      clearDatePickers(this, ['modalStartDateFilter', 'modalEndDateFilter']);
      this.filterSetModal = false;
      this.modalCurrentPage = 1;
      this.getAuditTrail(this.auditByFilters);
    },

    clearSearch() {
      this.auditEntityTypeId =
      this.userTypeId =
      this.adminUserId =
      this.taxPayerId =
      this.auditActionId =
      this.startDate =
      this.endDate = ''
      clearDatePickers(this, ['startDateFilter', 'endDateFilter']);
      this.filterSet = false;
      this.currentPage = 1;
      this.getAuditTrail();
    },

    searchAudit(disableNotification) {
      if (
        this.userTypeId
        || this.taxPayerId
        || this.adminUserId
        || this.auditActionId
        || this.auditEntityTypeId
        || (this.startDate && this.endDate)
      ) {
        if(!this.filterSet) this.currentPage = 1;

        this.filterSet = true;
        const filters = [];

        if (this.userTypeId) {
          filters.push({
            field: "user_type_id",
            value: this.userTypeId
          });
        }

        if (this.taxPayerId) {
          filters.push({
            field: "user_id",
            value: this.taxPayerId
          });

          filters.push({
            field: "user_type_id",
            value: constants.taxpayerUserTypeId
          });
        }

        if (this.adminUserId) {
          filters.push({
            field: "user_id",
            value: this.adminUserId
          });
          
          filters.push({
            field: "user_type_id",
            value: constants.adminUserType.id
          });
        }

        if (this.auditActionId) {
          filters.push({
            field: "action_id",
            value: this.auditActionId
          });
        }

        if (this.auditEntityTypeId) {
          filters.push({
            field: "entity_type_id",
            value: this.auditEntityTypeId
          });
        }

        if(this.startDate && this.endDate) {
          const startDate = this.$moment(this.startDate).format("YYYY-MM-DD 00:00:00");
          const endDate = this.$moment(this.endDate).format("YYYY-MM-DD 23:59:59");
          filters.push({
            field: "done_at",
            value: startDate,
            cond_op: ">="
          });

          filters.push({
            field: "done_at",
            value: endDate,
            cond_op: "<="
          });
        }

        let params = `filters=${JSON.stringify(filters)}`;
        this.tableData = [];
        this.getAuditTrail(params);
      } else {
        if (disableNotification) {
          this.filterSet ? this.clearSearch() : this.getAuditTrail();
        } else {
          this.notification(
            "You must enter at least one filter parameter",
            "error",
            "danger"
          );
        }
      }
    },

    getPaginationParams() {
      const { currentPage, pagination, modalCurrentPage, modalPagination } = this;
      if (this.showAuditModal) {
        return `page_size=${modalPagination.perPage}&page=${modalCurrentPage}`;
      }
      return `page_size=${pagination.perPage}&page=${currentPage}`;
    },

    getAuditTrail(params="") {
      const filterParams = `${params}&order_by=id&is_asc=0&exclude_total_count=${params? '0' : '1'}`;
      const apiUrl = "audit/trail";
      this.downloadLinks = this.downloadLinks.map(function(dl) {
        dl.params = `no_pages=1&${filterParams}`;
        dl.url = apiUrl;
        dl.method = "GET";
        return dl;
      });

      this.$http.post(apiUrl,
        {
          method: "GET",
          params: `${filterParams}&${this.getPaginationParams()}`
        }).then(
        response => {
          if (response.data) {
            if (response.data.error) {
              this._handleErrors(response.data);
            } else {
              if (this.showAuditModal) {
                this.modalTableData = response.data.list;
                this.modalPagination.total = response.data.pagination.total_count;
              } else {
                this.tableData = response.data.list;
                this.pagination.total = response.data.pagination.total_count;

                if (response.data.pagination && response.data.pagination.total_count) {
                  this.enableDownload = params !== "" && response.data.pagination.total_count <= 100
                }
              }
            }
          } else {
            this.notification(
              "An unknown error occurred",
              "pan_tool",
              "danger"
            );
          }
        },
        error => {
          this.notification(error.message, "clear", "danger");
        }
      );
    },

    getAuditEntityTypes(){
      this.$http.post("references/audit_entity_type/values",
        {
          method: "GET",
        }).then(
        response => {
          if (response.data) {
            if (!response.data.error) {
              this.auditEntityTypes = sortAlphabetically(response.data, 'name');
            }
          }
        },
        error => {
          this.notification(error.message, "clear", "danger");
        }
      );
    },

    getUserTypes(){
      this.$http.post("references/user_type/values",
        {
          method: "GET",
        }).then(
        response => {
          if (response.data) {
            if (!response.data.error) {
              this.userTypes = sortAlphabetically(response.data, 'name');
            }
          }
        },
        error => {
          this.notification(error.message, "clear", "danger");
        }
      );
    },

    getAuditActions(){
      this.$http.post("references/audit_action/values",
        {
          method: "GET",
        }).then(
        response => {
          if (response.data) {
            if (!response.data.error) {
              this.auditActions = sortAlphabetically(response.data, 'name');
            }
          }
        },
        error => {
          this.notification(error.message, "clear", "danger");
        }
      );
    },

    getAdmins(){
      const sortBy = orderBy('first_name');
      this.$http.post("admins",
        {
          method: "GET",
          params: `&no_pages=1${sortBy}`
        }).then(
        response => {
          if (response.data) {
            if (!response.data.error) {
              this.adminUsers = response.data.list;
            }
          }
        },
        error => {
          this.notification(error.message, "clear", "danger");
        }
      );
    },

    downloadDetail() {
      const element = document.getElementById('single-link-0');
      element.click();
    },

    _handleErrors(response) {
      if (response.data) {
        for (let message in response.data) {
          this.notification(response.data[message][0], "pan_tool", "danger");
        }
      } else {
        if(response.code !== 'ACCESS_DENIED') {
          this.notification(response.message, "pan_tool", "danger");
        }
      }
    },

    notification(message, icon, color) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: color
      });
    }
  },

  created() {
    const canVisit = constants.userCan(['audit.getall']);
    if(!canVisit) {
      this.notification('You are not authorized', "pan_tool", "danger");
      this.$router.push('/dashboard');
    }
    this.getAuditTrail();
    this.getAuditEntityTypes();
    this.getUserTypes();
    this.getAuditActions();
    this.getAdmins();
  },

  watch: {
    currentPage() {
      this.searchAudit(true);
    },

    modalCurrentPage() {
      this.searchModalAudit();
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.green {
  background-color: #66bb6a !important;
  color: white !important;
}

.paginated-table .md-btn-fab,
.paginated-table .md-just-icon {
  margin: 5px !important;
}

.paginated-table .md-table-head.md-sortable .md-table-sortable-icon {
  left: 70% !important;
}

.capitalize {
  text-transform: capitalize;
}

.selectGroup {
  display: flex;
  flex-direction: column;
  max-width: 200px;
  padding-left: 0;
  margin-right: 20px;
  margin-top: 8px;
}

.selectGroup label {
  margin-bottom: 10px;
  /* position: static; */
}

.selectGroup select {
  margin-bottom: 10px;
}

.md-toolbar {
  background-color: #fff !important;
}
.filter-btns {
  width: 100%;
  margin-top: 10px;
}
.flt-btns {
  float: right;
}
.btn-lft {
  margin-right: 6px;
}
.page-ttl {
  float: left;
  margin-right: 10px;
}
.md-ripple {
  z-index: auto !important;
}
.details-block p {
  font-size: 12px;
}
.details-block p b{
  text-transform: capitalize;
}
.details-block p {
  margin: 2px;
}
.details-block p span {
  font-weight: 400;
  padding-left: 10px;
}
a.view-more {
  color: #00bcd4;
}
</style>
